module.exports = __webpack_public_path__ + "static/media/Treasure.7bcc2a07.svg";